// Prevent closing from click inside dropdown
$(document).on('click', '.dropdown-menu', function (e) {
	e.stopPropagation();
});

function extraUrlCondition() {

	const disableLink = $('#primary-menu .menu-item a[href*="#"]');
	const disabledForClick = disableLink.closest('li');

	disabledForClick.addClass("disabled");

	$('.menu-item-has-children > a').on('click', function (event) {
		if ($(this).attr('href') === '#') {
			event.preventDefault();
		}
	});

	$('.menu-item-has-children').each(function () {
		$(this).append('<span class="el-for-click"></span>');
	});
	const elForClick = $('.el-for-click');

	$(elForClick).on('click', function (event) {
		event.preventDefault();

		$(this).toggleClass('active');
		$(this).siblings('.dropdown-menu').toggleClass('show');
	});

}

function dropdownHover() {
	if ($(document).width() > 992) {
		$(".menu-item-has-children").hover(
			function (e) {
				e.preventDefault();
				$(this)
					.find(".dropdown-menu")
					.addClass("show");
			},
			function () {
				$(this)
					.find(".dropdown-menu")
					.removeClass("show");
			}
		);

		$(".dropdown-menu li").hover(
			function (e) {
				e.preventDefault();
				$(this)
					.find(".dropdown-submenu")
					.eq(0).addClass("show");
			},
			function () {
				$(this)
					.find(".dropdown-submenu")
					.eq(0).removeClass("show");
			}
		);
		$(".dropdown-menu ul.dropdown-menu").mouseenter(function (e) {
			e.preventDefault();
			$(this).addClass("show");
		});
	}
}

jQuery(document).ready(() => {

	$('.navbar-toggler').click(function () {
		$('.top_header__menu').animate({'left': '0'}, 700);
		$('.header').addClass('dark_bg');
		$('#primaryNavBar').removeClass('show');
		document.body.style.overflow = 'hidden';
	});

	function closeNav() {
		$('.top_header__menu').animate({'left': '-100%'}, 700);
		$('.header').removeClass('dark_bg');
		document.body.style.overflow = 'auto';
	}

	$('.close_menu').click(function(){
		closeNav();
	});

	//close menu
	const elBg = (".header.dark_bg");

	$("body").click(function (e) {
		if ($(e.target).is(elBg)) {
			closeNav();
		}
	});

	$(window).resize(function () {
		const win = $(this);
		if (win.width() >= 992) {
			$('.top_header__menu').animate({'left': '-100%'}, 700);
			$('#primaryNavBar').removeClass('show');
			$('.header').removeClass('dark_bg');
			$('.navbar-nav').find('.menu-item.show').removeClass('show');
			$('.dropdown-menu').removeClass('show').removeAttr('style');
			$('.el-for-click').removeClass('active');
			document.body.style.overflow = 'auto';
		}
		dropdownHover();
	});

	extraUrlCondition();
	dropdownHover();

	//animate top_header__overlay bg on scroll
	$(window).scroll(function () {
		let findScroll = $(window).scrollTop();
		let findOpacity = 0;

		if (findScroll < 198) {
			findOpacity = 0;
		} else if (findScroll >= 198 && findScroll <= 300) {
			findOpacity = (findScroll - 198) / 100;
		} else {
			findOpacity = 1;
		}
		$('.top_header__overlay').css('opacity', findOpacity);
	});


	//Smooth Scroll
	$('a[href*="#"]')
		.not('[href="#"]')
		.not('[href="#0"]')
		.click(function (event) {
			if (
				location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
				&&
				location.hostname == this.hostname
			) {
				let target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

				if (target.length) {
					event.preventDefault();
					$(this).siblings().removeClass('active');
					$(this).addClass('active');
					let top = 90;
					$('html, body').animate({
						scrollTop: target.offset().top - top,
					}, 500);
					closeNav();
				}
			}
		});
});



// WEBPACK FOOTER //
// ./scripts/modules/_header.js